<template>
  <!-- TODO: copypaste of MaterialEditorBlockNodeViewWrapper - resolve after editor refactor -->
  <NodeViewWrapper data-extension-name="table">
    <div data-drag-handle="">
      <div draggable="true" class="my-4 p-1" @dragover.prevent="">
        <NodeViewContent as="table" />
      </div>
    </div>
  </NodeViewWrapper>
</template>

<script setup lang="ts">
import type { NodeViewProps } from '@tiptap/core';
import { NodeViewContent, NodeViewWrapper } from '@tiptap/vue-3';

// eslint-disable-next-line vue/prop-name-casing
defineProps<NodeViewProps>();
</script>
